import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        component: () => import('../views/MainLayout.vue'),
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'home',
                component: () => import('../views/Home.vue')
            },
            {
                path: 'checkin',
                name: 'checkin',
                component: () => import('../views/CheckIn.vue')
            },
            {
                path: 'mine',
                name: 'mine',
                component: () => import('../views/Mine.vue')
            },
            {
                path: 'dailyReward',
                name: 'dailyReward',
                component: () => import('../views/dailyReward.vue')
            },
            {
                path: '/invitation',
                name: 'invitation',
                component: () => import('../views/invitation.vue')
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/test',
        name: 'test',
        component: () => import('../views/test.vue')
    },
    {
        path: '/withdraw',
        name: 'withdraw',
        component: () => import('../views/Withdraw.vue')
    },
    {
        path: '/messageNotice',
        name: 'messageNotice',
        component: () => import('../views/messageNotice.vue')
    },
    {
        path: '/CheckInRules',
        name: 'CheckInRules',
        component: () => import('../views/CheckInRules.vue')
    },
    {
        path: '/set/settings',
        name: 'set/settings',
        component: () => import('../views/set/settings.vue')
    },
    {
        path: '/set/accountSafe',
        name: 'set/accountSafe',
        component: () => import('../views/set/accountSafe.vue')
    },
    {
        path: '/set/accountLogout',
        name: 'set/accountLogout',
        component: () => import('../views/set/accountLogout.vue')
    },
    {
        path: '/set/aboutAs',
        name: 'set/aboutAs',
        component: () => import('../views/set/aboutAs.vue')
    },
    {
        path: '/accountDetail',
        name: 'accountDetail',
        component: () => import('../views/AccountDetail.vue')
    },
    {
        path: '/cashRecord',
        name: 'cashRecord',
        component: () => import('../views/CashRecord.vue')
    },
    {
        path: '/PrivacyPolicy',
        name: 'PrivacyPolicy',
        component: () => import('../views/privacy/PrivacyPolicy.vue')
    },
    {
        path: '/UserAgreement',
        name: 'UserAgreement',
        component: () => import('../views/privacy/UserAgreement.vue')
    },
    {
        path: '/AccountDeletion',
        name: 'AccountDeletion',
        component: () => import('../views/privacy/AccountDeletion.vue')
    },
    {
        path: '/privacy/oaid-guide',
        name: 'OaidGuide',
        component: () => import('../views/privacy/OaidGuide.vue')
    },
    {
        path: '/service',
        name: 'service',
        component: () => import('../views/service.vue')
    },
    {
        path: '/kf-service',
        name: 'kf-service',
        component: () => import('../views/KfService.vue')
    },
    {
        path: '/MyCoupons',
        name: 'MyCoupons',
        component: () => import('../views/MyCoupons.vue')
    },
    {
        path: '/inviteDetail',
        name: 'inviteDetail',
        component: () => import('../views/inviteDetail.vue')
    },
    {
        path: '/rewardDetail',
        name: 'rewardDetail',
        component: () => import('../views/rewardDetail.vue')
    },
    {
        path: '/fissionTierReward',
        name: 'fissionTierReward',
        component: () => import('../views/FissionTierReward.vue')
    },
    {
        path: '/pastFissionTierReward',
        name: 'pastFissionTierReward',
        component: () => import('../views/pastFissionTierReward.vue')
    },
    {
        path: '/apprenticeTierReward',
        name: 'apprenticeTierReward',
        component: () => import('../views/ApprenticeTierReward.vue')
    },
    {
        path: '/pastApprenticeTierReward',
        name: 'pastApprenticeTierReward',
        component: () => import('../views/PastApprenticeTierReward.vue')
    },
    {  path: '/coinExchange',
        name: 'coinExchange',
        component: () => import('../views/CoinExchange.vue')
    },
    {
        path: '/newPeopleActivity',
        name: 'newPeopleActivity',
        component: () => import('../views/NewPeopleActivity.vue')
    }


]

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_PUBLICPATH),
    routes
})

export default router
